export let i18n = {
    //locales: ['en', 'de', 'fr', 'it', 'se', 'pt'],
    //localeNames: ['English', 'Deutsch', 'Français', 'Italiano', 'Svenska', 'Português'],
    locales: ['en', 'de'],
    localeNames: ['English', 'Deutsch'],
    defaultLocale: 'en',
}

export type Locale = (typeof i18n)["locales"][number]


export const defaultLocale = 'en';

export const languageList = [
    {
        locale: 'en',
        localeName: 'English'
    },
    {
        locale: 'de',
        localeName: 'Deutsch'
    },
    {
        locale: 'fr',
        localeName: 'Français'
    },
    {
        locale: 'it',
        localeName: 'Italiano'
    },
    {
        locale: 'se',
        localeName: 'Svenska'
    },
    {
        locale: 'pt',
        localeName: 'Português'
    }
];